export const getOptions = (min, max) => {
    const optionList = [];
    if (min > max) {
        optionList.push({
            label: min,
            value: min
        });
    }
    else {
        for (let i = min; i <= max; i++) {
            optionList.push({
                label: i,
                value: i
            });
        }
    }
    return optionList;
};

export const getIntelFormSubmitData = ({
    composition,
    bgControl,
    sizeControl,
    referPic,
    creativeStyle,
    referDegree
}, templateCreated = false) => {
    const type = composition.type;

    const logInfo = {
        composition: type,
        sizeType: sizeControl.type,
        bgType: bgControl.type
    };

    const getSizeParams = () => {
        const sizeList = sizeControl.value.dimension.split('*');
        const width = +sizeList[0];
        const height = +sizeList[1];
        const ratioNum = height / width;
        const ratio = sizeControl.value.ratio ? `RATIO_${sizeControl.value.ratio.replace(/:/g, '_')}` : '';

        logInfo.ratio = ratioNum;
        logInfo.size = `${width}*${height}`;

        return {width, height, ratio, ratioNum};
    };

    const getBackgroundParams = () => {
        const basePrompt = bgControl.value.prompt || '';
        const backgroundPrompt = bgControl.value.aiPrompt || basePrompt;
        const backgroundType = 'generate';
        const basePromptType = bgControl.value.aiPrompt ? 'useAiExpand' : 'input';
        // 从灵感页面或右侧灵感列表点击生成相似时，会传promptType进来，
        // 即使用户把prompt内容完全更改了，也仍旧认为是标记为生成相似，所以中途编辑不会改变promptType
        // 如果bgControl.promptType不存在，说明不是灵感带进来的，则赋值basePromptType
        const promptType = bgControl.promptType || basePromptType;

        return {
            basePrompt,
            backgroundPrompt,
            backgroundList: [],
            style: '',
            backgroundType,
            promptType
        };
    };

    const getReferInfo = () => {
        const refScaleMap = {1: 'low', 2: 'middle', 3: 'high'};
        const {image: [firstImage] = [{ }]} = referPic || {};

        if (firstImage?.url) {
            return {
                refImage: firstImage?.url || '',
                refImageEdge: firstImage?.outlineUrl || '',
                refMode: (firstImage?.type || []).map(item => item.name)[0] || '',
                refScale: refScaleMap?.[firstImage?.degree] || '',
                textBox: firstImage?.textBox
            };
        }
        const {image: [creativeFirstImage] = [{ }]} = creativeStyle || {};
        if (creativeFirstImage && creativeFirstImage.type) {
            const {type} = creativeFirstImage;
            if (type && Array.isArray(type) && type.length) {
                return {
                    creativeStyle: type.filter(item => item.loraWord)[0]?.loraWord || '',
                    styleType: type.filter(item => item.label)[0]?.styleType,
                    styleModel: type.filter(item => item.label)[0]?.label || '',
                    useStyleModel: type.filter(item => item.useStyleModel)[0]?.useStyleModel || 0,
                    styleRecognition: creativeFirstImage.styleRecognition || 0
                };
            }
        }
    };

    const params = {
        ...getReferInfo(),
        ...getSizeParams(),
        ...getBackgroundParams(),
        // 根据是否模版叠加来判断是否保存
        // saveStatus: !templateCreated,
        saveStatus: true,
        imageGenerateType: templateCreated ? 'BACKGROUND_V2_TMP' : 'BACKGROUND_V2'
    };

    return {
        type,
        params,
        logInfo,
        templateCreated
    };
};


// 格式化高级设计表单的参数
export const getDesignFormSubmitData = (data = {}, formConfig = [], imgList = [], targetCount = 1) => {
    const {
        templateGroup: {
            industry,
            sizeControl,
            template
        }
    } = data;
    let params = {
        imageGenerateType: 'NEW_TEMPLATE_GEN_IMAGE',
        businessPoint: '',
        targetCount
    };
    let replaceLayerMap = {};
    // 风险提示语临时mock清空
    replaceLayerMap['风险提示语'] = {
        label: '风险提示语',
        value: '',
        type: 'span'
    };
    // 根据底图的类型区分要替换的图层
    let needCutout = false;
    // 如果是模版选择，则指定模版ID，多个逗号拼接；如果是智能设计，则需要根据参数组装查询模版的tag
    params.name = template.chooseList.join(',');
    params.position = '';
    // 如果填写了文案，则需要带上文案的信息
    // 遍历formConfig，对type为textInput、visible是true的字段，data里对应的value不为空，则带上
    // 后端接口升级后，这里就可以去掉默认值了
    let posterJsonMatches = [{
        type: '主标题',
        name: ''
    }];
    // 没打开文案区域、或者没填的元素，把模版里自带的该文本元素给删掉，避免出来的文案与实际推广相差太大
    formConfig.forEach(item => {
        if ((item.type === 'textInput' || item.type === 'textInputCustom' || item.type === 'autoComplete')
            && data[item.name]
        ) {
            const label = item.layerName || item.label;
            let value = data[item.name].value;
            if (item.visible && value.length > 0) {
                posterJsonMatches.push({
                    type: label,
                    name: value
                });
            }
            else {
                // 如果隐藏状态，则此字段要清空
                value = '';
            }
            // needClear字段，可以让部分元素在未填写的时候指定不需要清空模版里的元素文案，例如按钮文案之类的
            // 但如果是重复的元素，已经赋值了、对于未显示出来的、不能重复赋值
            // 对需要清空的元素 ，如果可视、非空值，也需要替换
            if ((item.needClear === true && !(replaceLayerMap[label] != null && !item.visible))
                || (item.needClear !== true && item.visible && value !== '')
            ) {
                replaceLayerMap[label] = {
                    label,
                    value,
                    type: 'span'
                };
            }
        }
        else if (item.type === 'uploadImgCard') {
            const label = item.label === '品牌LOGO' ? 'LOGO图' : item.label;
            const value = data[item.name]?.image?.[0]?.url || '';
            if (value != null) {
                replaceLayerMap[label] = {
                    label,
                    value,
                    type: 'image'
                };
            }
        }
    });
    // 如果指定了模版ID查询，则不要带上元素匹配逻辑了
    if (posterJsonMatches.length > 0 && !params.name) {
        params.posterJsonMatches = posterJsonMatches;
    }
    // 把所有要替换的图片、文本都记录下来，后面使用
    params.replaceLayerMap = replaceLayerMap;
    params.replaceBaseList = imgList;

    // 指定图片尺寸
    const sizeList = sizeControl.value.dimension.split('*');
    params.width = +sizeList[0];
    params.height = +sizeList[1];
    params.needCutout = needCutout;
    params.ratioNum = params.height / params.width;


    params.logInfo = {
        cutout: needCutout,
        sizeType: sizeControl.type,
        ratio: params.ratioNum,
        size: `${params.width}*${params.height}`,
        trade: industry.value
    };

    return params;
};

// 提交表单时，需记录下来的有用的参数，供日志分析使用
export const getSubmitLogData = (data, activeTab) => {
    // 先得到表单格式化后的参数，然后只保留部分，拼成字符串返回
    let func = activeTab === 'intelForm' ? getIntelFormSubmitData : getDesignFormSubmitData;
    let formatData = typeof func === 'function' ? func(data) : {};
    let logInfo = formatData.logInfo || {};
    let logString = '';
    for (let key in logInfo) {
        if (logInfo.hasOwnProperty(key)) {
            logString += `${key}=${logInfo[key]}&`;
        }
    }
    return logString;
};

const positionTagMap = {
    'left': '居左',
    'right': '居右',
    'center': '居中',
    'top': '居上',
    'bottom': '居下'
};

export function getTemplateTags(needCutout = false, ratio = '', industryValue = '', position = '') {
    let tags = [];
    // 给营销图模块单独的标签
    // 更新，擎舵2.0标签是为了一键出图的模版区域带上。市场——图片模版页面，保持原本逻辑，显示全部模板
    tags.push('擎舵2.0');
    /**
     * 查询模版的过滤标签：
     * 如果是主体、带“有抠图”；其他的，“无抠图”
     * 按照比例，拼接比例标签，例如：模版中心_1:1
     * 如果选了行业，带行业标签，如：INDUSTRY:9
     */
    if (needCutout) {
        tags.push('有抠图');
    }
    else {
        tags.push('不抠图');
    }
    if (ratio) {
        tags.push(`模版中心_${ratio}`);
    }

    // 行业，可能一个行业选项有多个值，逗号split、过滤、然后拼接
    if (industryValue) {
        // todo，此处待后续逻辑确定后可能需要升级：多个行业应该是&拼接其他tag、行业之间用|链接
        industryValue.split(',').filter(str => str).forEach(id => {
            tags.push(`INDUSTRY:${id}`);
        });
    }
    // 布局
    if (positionTagMap[position]) {
        tags.push(`布局_${positionTagMap[position]}`);
    }
    return tags;
}